define('cart_promocode_list.tpl', ['Handlebars','Handlebars.CompilerNameLookup'], function(Handlebars, _nl_){
	return _wrap_fn_('cart_promocode_list', {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div data-view=\"PromocodeList\"></div>  ";
},"useData":true}, 'extensions/SC/Posh/3.5.5/', 'extensions/SC/Posh/3.5.5/', Handlebars);
});